const NOOP = () => {};
const DEFAULTS = { async: true, data: {}, id: null, onload: NOOP, preload: NOOP, src: null };
const scripts = [];

function maker({ async, data, id, onload, src }) {
  const script = document.createElement("script");

  script.async = async;
  Object.keys(data).forEach(datum => {
    script.dataset[datum] = data[datum];
  });

  if (id) {
    script.id = id;
  }

  script.addEventListener("load", onload);

  document.head.appendChild(script);
  script.src = src;
}

function ongtmscriptrequest({ detail }) {
  const options = Object.assign(DEFAULTS, detail || {});
  const { src } = options;

  options.onload = options.onload.bind(window); // set onload context to window
  options.preload.call(window); // run preload in window context

  // if there is no source or it has already been requested, immediately run onload
  if (!src || scripts.includes(src)) {
    options.onload();
  } else {
    scripts.push(src);
    maker(options);
  }
}

window.addEventListener("gtmscriptrequest", ongtmscriptrequest);



// WEBPACK FOOTER //
// ./shared/gtm-script-loader.js